export class ToolAppData {
  public name: string
  public assemblyName: string
  public className: string
  public id: string

  constructor(pName: string, pAssemblyName: string, pClassName: string, pId: string) {
    this.name = pName
    this.assemblyName = pAssemblyName
    this.className = pClassName
    this.id = pId
  }
}
